module.exports = __webpack_public_path__ + "static/media/16_b_2.f2521feb.png";